import i18n from '@/i18n';
import { getHblViewBreadCrumbs } from '@/modules/house-bl';
import { RouteConfig } from 'vue-router/types/router';
import { useToast } from '@/composables/useToast';
import { PermissionsImportFeatures } from '@/constants/permissions';

export const hblRoutes: RouteConfig[] = [
  {
    name: 'HouseBL',
    meta: {
      permission: PermissionsImportFeatures.HBL,
      disableWarehouseSwitch: true,
      dynamicTitle: true,
      pageTitle: 'HBL',
      breadCrumbs: getHblViewBreadCrumbs,
    },
    path: 'house-bl/view/:id',
    props: true,
    component: () => import('@/views/house-bl/house-bl-view/index.vue'),
  },
  {
    name: 'HouseBLCreate',
    meta: {
      permission: PermissionsImportFeatures.HBL,
      disableWarehouseSwitch: true,
      pageTitle: i18n.t('HBLCreate'),
    },
    path: 'house-bl/create',
    component: () => import('@/views/house-bl/HouseBLCreateView.vue'),

    beforeEnter: (to, from, next) => {
      if (to.query.mblId) {
        return next();
      }
      useToast().error('No MBL ID provided');
      return next({ name: 'ManifestImports' });
    },
  },
];
